module.exports = __webpack_public_path__ + "media/country_flags/kz-8c6a8d76.png";